export const waterData = [
    {
        id: 1,
        organisationName: "МУП «ЖКХ Лесной»*",
        service: 
        [
            {
                water: "питьевая вода",
                prices22: "37,58",
                prices23: "38,21",
            },
            {
                water: "водоотведение",
                prices22: "48,85",
                prices23: "49,67"
            },
        ]
    },

    {
        id: 2,
        organisationName: "ООО «Софрино»**",
        service: 
        [
            {
                water: "питьевая вода",
                prices22: "22,63",
                prices23: "23,01",
            },
            {
                water: "водоотведение",
                prices22: "29,78",
                prices23: "30,20"
            },
        ]
    }
]